import { render, staticRenderFns } from "./SupplierRestaurantLinkDialog.vue?vue&type=template&id=1648f476"
import script from "./SupplierRestaurantLinkDialog.vue?vue&type=script&lang=js"
export * from "./SupplierRestaurantLinkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports